@if (careproviderUnit() !== null) {
  @if (displayBookingBtn()) {
    <div [ngClass]="bottomSectionCssClass()"
         class="bottom-0 left-0 right-0 flex flex-col justify-stretch gap-4 p-4 w-full border-t border-grey-9 fixed lg:hidden z-3 bg-white"
    >
      @for (config of bookingConfigurationData(); track config.id) {
        <app-booking-btn
          [bookingConfigurationData]="config"
          [caregiverContactInfo]="careproviderUnit()?.caregiverContactInfo"
          [classList]="'booking-btn__narrow'"
          [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
          [pageType]="dLPageTypeEnum.CARE_SERVICE_PAGE"
          size="lg"
        ></app-booking-btn>
      }
    </div>
  }

  <div class="row full-width-bg" id="component-top">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
    </div>
  </div>


  <div
    (inViewportAction)="handleTabsInViewport($event)"
    [inViewportOptions]="{threshold: 0}"
    class="tabs-viewport-marker full-width-bg"
    inViewport
  >
    <div [ngStyle]="placeholderStyle()"></div>
    <div [ngClass]="topSectionCssClass()"
         class="top-section bg-white border-b-2 border-b-grey-9 flex justify-center items-start"
         id="top-section-container">
      <div class="max-w-[1184px] w-full">

        <div class="top-info-container flex flex-col mt-4 lg:flex-row gap-5 lg:gap-6">
          <app-cpru-top-info-img-section></app-cpru-top-info-img-section>
          <app-cpru-top-info-desc-section></app-cpru-top-info-desc-section>
        </div>
        <app-cpru-top-info-short [pageType]="dLPageTypeEnum.CARE_PROVIDER_PAGE"></app-cpru-top-info-short>

        @if (isMobile() && careproviderUnit()?.externalReviewSummary) {
          <app-cpru-reviews-short
            [externalReviews]="careproviderUnit()?.externalReviewSummary"></app-cpru-reviews-short>
        }

        <div class="tabs-container min-h-12">
          <nav [tabPanel]="tabPanel" mat-align-tabs="start" mat-stretch-tabs="false" mat-tab-nav-bar>
            @for (link of tabs(); track link.name) {
              <a mat-tab-link
                 (click)="cpruTabsService.handleTabsIndexChange(link.name)"
                 [active]="highlightedSection() === link.name"> {{ link.label }} </a>
            }
          </nav>
          <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col">
      <div class="flex flex-col gap-12 md:gap-3">

        @if (careproviderUnit()?.careServices && careproviderUnit()?.careServices.length > 0) {
          <section id="section-{{ routesAddonsEnums.CAREPROVIDER_SERVICES }}">
            <app-care-service-list
              [bookingSettings]="careproviderUnit()?.bookingSettings"
              [bordered]="false"
              [careProviderContactInfo]="careproviderUnit()?.caregiverContactInfo"
              [careProviderUnitId]="careproviderUnit()?.id"
              [careProviderUnitName]="careproviderUnit()?.name"
              [careProviderUnitUrlPath]="careproviderUnit()?.urlPath"
              [careProviderUnitUrl]="careProviderUnitUrl()"
              [careServices]="careproviderUnit()?.careServices"
              [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
              [queryParams]="queryParams()"
              [selectedId]="null"
            ></app-care-service-list>
          </section>
        }


        <section id="section-{{ routesAddonsEnums.CAREPROVIDER_ABOUT }}">
          <app-cpru-about></app-cpru-about>
        </section>

        @if (isMobile() && !careproviderUnit().isCustomer) {
          <section class="show-on-mobile" id="section-{{routesAddonsEnums.CAREPROVIDER_BOOKTIMENOW}}">
            <app-book-time-now-widget
              [careProviderUnitId]="careproviderUnit().id"
              [inferredCareProviderTypeAreaId]="
                                          careproviderUnit().mainCaregiverUnitType?.area?.id
                                        "
              [inferredCategoryTypeId]="
                                          careproviderUnit().mainCaregiverUnitType?.id
                                        "
              [lat]="careproviderUnit().address?.latitude"
              [lon]="careproviderUnit().address?.longitude"
              [mainCareProviderTypeId]="
                                          careproviderUnit().mainCaregiverUnitType?.id
                                        "
              [mainCareProviderUnitTypeUrlPath]="
                                    careproviderUnit().mainCaregiverUnitType?.urlPath
                                  "
              [pageType]="dLPageTypeEnum.HSA_CARE_PROVIDER_PAGE"
              [useExpand]="true"
            ></app-book-time-now-widget>
          </section>
        }

        @if (!careproviderUnit().isCustomer) {
          <section id="section-become">
            <app-cpru-become></app-cpru-become>
          </section>
        }

        @if (!careproviderUnit().isCustomer) {
          <section id="section-update">
            <app-cpru-update [careProviderUnitId]="careproviderUnit().id"></app-cpru-update>
          </section>
        }


        @if (survey() != null) {
          <section id="section-{{ routesAddonsEnums.CAREPROVIDER_SURVEY }}">
            <app-cpru-survey
              [name]="careproviderUnit().name"
              [survey]="survey()"
            ></app-cpru-survey>
          </section>
        }


        @if (visitorQuestions() && visitorQuestions().length > 0) {
          <section id="section-{{ routesAddonsEnums.CAREPROVIDER_QUESTIONS }}">
            <app-cpru-questions
              [careproviderUnitId]="careproviderUnit().id"
              [careproviderUnitName]="careproviderUnit().name"
              [visitorQuestions]="visitorQuestions()"
            ></app-cpru-questions>
          </section>
        }

        @if (hasStaff() && !isMobile()) {
          <section class="show-on-desktop"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_STAFF }}">
            <app-cpru-staff-list
              [staffMembers]="careproviderUnit()?.staffMembers"
            ></app-cpru-staff-list>
          </section>
        }

        @if (hasReferral() && !isMobile()) {
          <section class="show-on-desktop"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_REFERRAL }}">
            <app-cpru-referral></app-cpru-referral>
          </section>
        }


        @if (hasContact() && !isMobile()) {
          <section
            class="show-on-desktop"
            id="section-{{ routesAddonsEnums.CAREPROVIDER_CONTACT }}">
            <app-cpru-contact
              [bookingSettings]="careproviderUnit()?.bookingSettings"
              [id]="careproviderUnit()?.id"
              [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
              [phoneNumbers]="careproviderUnit()?.caregiverContactInfo?.phoneNumbers"
              [websiteUrl]="careproviderUnit()?.caregiverContactInfo?.websiteUrl"
            ></app-cpru-contact>
          </section>
        }

        @if (hasOpenHours() && !isMobile()) {
          <section class="show-on-desktop"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_OPENHOURS }}">
            <app-cpru-open-hours
              [serviceHours]="careproviderUnit()?.serviceHours"
            ></app-cpru-open-hours>
          </section>
        }

        @if (shouldDisplayCloseBy() && closeByHavePuffs()) {
          @defer (on viewport) {
            <app-closeby-carousel-v3
              (dataLoaded)="onCloseByDataLoaded($event)"
              (puffsShowOnChange)="closeByPuffsChanged($event)"
              [careproviderUnitId]="careproviderUnit().id"
              [address]="careproviderUnit().address"
              [mainCaregiverUnitType]="careproviderUnit().mainCaregiverUnitType"
              [isPageWithSidebar]="true"
              [pageType]="dLPageTypeEnum.HSA_CARE_PROVIDER_PAGE"
            >
            </app-closeby-carousel-v3>
          } @placeholder {
            <div class="w-100 h-[47rem]"></div>
          }
        }

        @if (isMobile() === false && this.careproviderUnit() && this.careproviderUnit().hsaObjects && this.careproviderUnit().hsaObjects.length > 0) {
          <section
            class="show-on-desktop">
            <app-cpru-related></app-cpru-related>
          </section>
        }

      </div>
    </div>

    <div class="col-slg mt-3 lg:mt-0">
      <div class="flex flex-col gap-12 md:gap-3">

        @if (careproviderUnit()?.externalReviewSummary) {
          <section id="section-{{ routesAddonsEnums.CAREPROVIDER_IMPRESSION }}">
            <app-external-reviews
              [externalReviews]="careproviderUnit()?.externalReviewSummary"
            ></app-external-reviews>
          </section>
        }

        <section id="section-{{ routesAddonsEnums.CAREPROVIDER_REVIEWS }}">
          <app-ratings-list
            [cpruId]="careproviderUnit()?.id"
            [externalReviews]="careproviderUnit()?.externalReviewSummary"
            [name]="careproviderUnit()?.name"
            [reviewSettings]="careproviderUnit()?.reviewSettings"
            [reviewSummary]="careproviderUnit()?.reviewSummary"
            [reviews]="careproviderUnit()?.reviews"
          ></app-ratings-list>
        </section>

        @if (!isMobile() && !careproviderUnit().isCustomer) {
          <section class="show-on-desktop" id="section-{{routesAddonsEnums.CAREPROVIDER_BOOKTIMENOW_SIDEBAR}}">
            <app-book-time-now-widget
              [careProviderUnitId]="careproviderUnit().id"
              [inferredCareProviderTypeAreaId]="
                                    careproviderUnit().mainCaregiverUnitType?.area?.id
                                  "
              [inferredCategoryTypeId]="careproviderUnit().mainCaregiverUnitType?.id"
              [lat]="careproviderUnit().address?.latitude"
              [lon]="careproviderUnit().address?.longitude"
              [mainCareProviderTypeId]="careproviderUnit().mainCaregiverUnitType?.id"
              [mainCareProviderUnitTypeUrlPath]="
                      careproviderUnit().mainCaregiverUnitType?.urlPath
                    "
              [pageType]="dLPageTypeEnum.HSA_CARE_PROVIDER_PAGE"
              [useExpand]="true"
            ></app-book-time-now-widget>
          </section>
        }


        @if (hasStaff() && isMobile()) {
          <section class="show-on-mobile"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_STAFF }}">
            <app-cpru-staff-list
              [staffMembers]="careproviderUnit()?.staffMembers"
            ></app-cpru-staff-list>
          </section>
        }


        @if (hasReferral() && isMobile()) {
          <section class="show-on-mobile"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_REFERRAL }}">
            <app-cpru-referral></app-cpru-referral>
          </section>
        }


        @if (hasContact() && isMobile()) {
          <section class="show-on-mobile"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_CONTACT }}">
            <app-cpru-contact
              [bookingSettings]="careproviderUnit()?.bookingSettings"
              [id]="careproviderUnit()?.id"
              [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
              [phoneNumbers]="careproviderUnit()?.caregiverContactInfo?.phoneNumbers"
              [websiteUrl]="careproviderUnit()?.caregiverContactInfo?.websiteUrl"
            ></app-cpru-contact>
          </section>
        }


        @if (hasOpenHours() && isMobile()) {
          <section class="show-on-mobile"
                   id="section-{{ routesAddonsEnums.CAREPROVIDER_OPENHOURS }}">
            <app-cpru-open-hours
              [serviceHours]="careproviderUnit()?.serviceHours"
            ></app-cpru-open-hours>
          </section>
        }


        @if (hasMap()) {
          <section id="section-{{ routesAddonsEnums.CAREPROVIDER_MAP }}">
            <app-cpru-map
              [address]="careproviderUnit()?.address"
              [caregiverUnitImages]="careproviderUnit()?.caregiverUnitImages"
              [id]="careproviderUnit()?.id"
              [name]="careproviderUnit()?.name"
              [urlPath]="careproviderUnit()?.urlPath"
            ></app-cpru-map>
          </section>
        }


        @if (isMobile() && this.careproviderUnit() && this.careproviderUnit().hsaObjects && this.careproviderUnit().hsaObjects.length > 0) {
          <section
            class="show-on-mobile">
            <app-cpru-related></app-cpru-related>
          </section>
        }

      </div>
    </div>
  </div>
}
